/**
 * Internal dependencies
 */
import webTransforms from './transforms.js';

const transforms = {
	...webTransforms,
	supportedMobileTransforms: [],
};

export default transforms;
